import useWindowSize from './useWindowSize';
import { BREAKPOINT_XL_MIN } from '../constants';

export default function useLgBreakpoint(): boolean {
    const { width } = useWindowSize();

    return width < BREAKPOINT_XL_MIN;
}
